"use client";
import React, { useState } from "react";
import styles from "./fivestar.module.scss";
import icon2 from "../../../public/img/5star/icon2.png";
import icon3 from "../../../public/img/5star/icon3.png";
import icon4 from "../../../public/img/5star/icon4.png";
import icon5 from "../../../public/img/5star/icon5.png";
import icon7 from "../../../public/img/5star/icon7.png";
import bgimage from "../../assets/images/bg-2.png";
import advantagesheader from "@/assets/images/adv-header.png";
import iconadv from "@/assets/images/icon-adv.jpg";
import skv from "@/assets/images/skv.png";
import s2 from "@/assets/images/s2.png";
import s3 from "@/assets/images/s3.png";
import s4 from "@/assets/images/s4.png";
import s5 from "@/assets/images/s5.png";
import s6 from "@/assets/images/s6.png";
import s7 from "@/assets/images/s7.png";
import s8 from "@/assets/images/s8.png";
import s9 from "@/assets/images/s9.png";
import s10 from "@/assets/images/s10.png";
import s11 from "@/assets/images/s11.png";
import s12 from "@/assets/images/s12.png";
import s13 from "@/assets/images/s13.png";
import s14 from "@/assets/images/s14.png";
import Image from "next/image";
import Modal from "react-bootstrap/Modal";

const ProductDetailsFivestar = () => {
  return (
    <>
      <div className="col-md-12">
        {/* <hr /> */}
        {/* <div className={styles.sencofiveyear}>
          <h1>The Five-Star Promise of Senco</h1>
          <div className={styles.sencofiveyear_main}>
            <div className="row">
              <div className="col-md-12" id="number">
                <div className={styles.icon_box}>
                  <div className={styles.first}>
                    <div className={styles.icon}>
                      <div className={styles.h4}>Purity</div>
                      <div className={styles.icon_box_m}>
                        <Image src={icon2} alt="icon2" />
                      </div>
                      <div className={styles.number}>1</div>
                    </div>

                    <div className={styles.text1}>
                      Certified Hallmarked jewellery.
                    </div>
                  </div>

                  <div className={styles.first}>
                    <div className={styles.icon}>
                      <div className={styles.h4}>Craftsmanship</div>
                      <div className={styles.icon_box_m}>
                        <Image src={icon3} alt="icon3" />
                      </div>
                      <div className={styles.number}>2</div>
                    </div>

                    <div className={styles.text1}>
                      Meticulous craftsmanship by Kolkata karigars
                    </div>
                  </div>

                  <div className={styles.first}>
                    <div className={styles.icon}>
                      <div className={styles.h4}>Legacy</div>
                      <div className={styles.icon_box_m}>
                        <Image src={icon4} alt="icon4" />
                      </div>
                      <div className={styles.number}>3</div>
                    </div>

                    <div className={styles.text1}>
                      Over50 years of legacy of integrity, Artistry and
                      dedication/Customer
                    </div>
                  </div>
                  <div className={styles.first}>
                    <div className={styles.icon}>
                      <div className={styles.h4}>Trust & Transparency</div>
                      <div className={styles.icon_box_m}>
                        <Image src={icon5} alt="icon5" />
                      </div>
                      <div className={styles.number}>4</div>
                    </div>

                    <div className={styles.text1}>
                      Recognized by TRA as the 2nd most trusted brand
                    </div>
                  </div>

                  <div className={styles.first}>
                    <div className={styles.icon}>
                      <div className={styles.h4}>Exquisite Design</div>
                      <div className={styles.icon_box_m}>
                        <Image src={icon7} alt="icon7" />
                      </div>
                      <div className={styles.number}>5</div>
                    </div>

                    <div className={styles.text1}>
                      Contemporary designs and Kolkata karigar’s finesse
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className={styles.advantages_main}>
          <div className={`${styles.container} ${"container mb-4"}`}>
            <div className={styles.advantages_main_header}>
              <Image src={advantagesheader} alt="" />
            </div>
            <div className={styles.advantages_main_body}>
              <div className="row justify-content-center g-3">
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={iconadv} alt="" />
                      </div>
                      <div className={styles.h4}>Over 8 decades of legacy</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s2} alt="" />
                      </div>
                      <div className={styles.h4}>2nd most trusted brand</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s3} alt="" />
                      </div>
                      <div className={styles.h4}>Our world-class karigari </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.h4}>
                        <div className={styles.icon_adv}>
                          <Image src={s4} alt="" />
                        </div>
                        Bis hallmarked purest gold
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s5} alt="" />
                      </div>
                      <div className={styles.h4}>Right pricing</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s6} alt="" />
                      </div>
                      <div className={styles.h4}>Free lifetime maintenance</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s7} alt="" />
                      </div>
                      <div className={styles.h4}>
                        Exchange & buyback guarantee
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s8} alt="" />
                      </div>
                      <div className={styles.h4}>
                        Certified genuine diamonds
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s14} alt="" />
                      </div>
                      <div className={styles.h4}>Earn rewarding points</div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s10} alt="" />
                      </div>
                      <div className={styles.h4}>EMI on diamond jewellery</div>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s11} alt="" />
                      </div>
                      <div className={styles.h4}>Responsible jeweller</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s12} alt="" />
                      </div>
                      <div className={styles.h4}>Insured diamond jewellery</div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s13} alt="" />
                      </div>
                      <div className={styles.h4}>Omni-Channel Service</div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 d-none-mobile-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.h3}>
                        A world of benefits. crafted for you
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-4 col-lg-3 col-6">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.icon_adv}>
                        <Image src={s9} alt="" />
                      </div>
                      <div className={styles.h4}>
                        Rewarding Monthly Saving Scheme
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6 d-none-desktop-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex  justify-content-md-start">
                      <div className={styles.h3}>
                        A world of benefits. crafted for you
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <hr /> */}
      </div>
    </>
  );
};

export default ProductDetailsFivestar;
